import React from "react";

const FooterInstagramIcon = (): JSX.Element => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 319.81 319.81"
  >
    <defs>
      <clipPath id="clip-path-3a" transform="translate(-146.1 -138.84)">
        <path
          className="cls-1"
          fill="none" clipRule="evenodd" d="M401,221.15A17.45,17.45,0,1,1,383.6,203.7,17.44,17.44,0,0,1,401,221.15Zm-95,126a48.46,48.46,0,1,0-48.45-48.46A48.45,48.45,0,0,0,306,347.2Zm0-123.1a74.65,74.65,0,1,1-74.65,74.64A74.65,74.65,0,0,1,306,224.1Zm0-44.54c-38.81,0-43.41.16-58.74.86-14.18.64-21.87,3-27,5A48.07,48.07,0,0,0,192.67,213c-2,5.11-4.35,12.82-5,27-.7,15.32-.84,19.93-.84,58.74s.14,43.41.84,58.75c.65,14.17,3,21.86,5,27a48.07,48.07,0,0,0,27.59,27.59c5.13,2,12.82,4.36,27,5,15.32.7,19.93.85,58.74.85s43.42-.15,58.74-.85c14.18-.65,21.87-3,27-5a48.07,48.07,0,0,0,27.59-27.59c2-5.12,4.35-12.81,5-27,.7-15.34.84-19.93.84-58.75s-.14-43.42-.84-58.74c-.65-14.17-3-21.88-5-27a48.07,48.07,0,0,0-27.59-27.59c-5.13-2-12.82-4.36-27-5C349.41,179.72,344.81,179.56,306,179.56Zm0-26.18c39.48,0,44.42.16,59.94.87s26,3.15,35.28,6.76a74.32,74.32,0,0,1,42.52,42.5c3.59,9.25,6,19.82,6.76,35.3s.87,20.45.87,59.93-.18,44.43-.87,59.94-3.17,26-6.76,35.28a74.36,74.36,0,0,1-42.52,42.52c-9.25,3.59-19.82,6-35.28,6.76s-20.46.87-59.94.87-44.42-.17-59.94-.87-26-3.17-35.28-6.76A74.36,74.36,0,0,1,168.26,394c-3.59-9.24-6-19.81-6.76-35.28s-.87-20.45-.87-59.94.18-44.43.87-59.93,3.17-26.05,6.76-35.3A74.32,74.32,0,0,1,210.78,161c9.25-3.61,19.82-6.06,35.28-6.76S266.52,153.38,306,153.38Z"
        />
      </clipPath>
      <clipPath id="clip-path-3b" transform="translate(-146.1 -138.84)">
        <rect className="cls-2" fill="none" x="160.63" y="153.38" width="290.74" height="290.74" />
      </clipPath>
    </defs>
    <g className="cls-3" clip-path="url(#clip-path-3a)">
      <g className="cls-4">
        <g className="cls-5" clip-path="url(#clip-path-3a)">
          <g className="cls-5" clip-path="url(#clip-path-3b)">
            <rect width="319.81" height="319.81" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default FooterInstagramIcon;
